import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { INITPAGING, NOTIFY } from "../based/Constants";
import TableFooter from "../based/content/TableFooter";
import { SwichToogle } from "../based/inputs/SwitchToogle";
import TFUSelect from "../based/inputs/TFUSelect";
import LoadingR from "../based/LoadingR";
import { Notify } from "../based/Notify";
import PartnerServices from "../based/services/PartnerServices";
import Breadcum from "../layout/refactor/Breadcum/Breadcum";
import TrashIcon from "./assets/TrashIcon.svg";
import { useHistory } from "react-router-dom";
import { ConfirmDialog } from "../based/Dialog";

function EditGroupCustomize(props) {
    const history = useHistory();
    const { setId } = props.match.params;
    const [loading, setLoading] = useState(false);
    const [model, setModel] = useState({});
    const [listDesign, setListDesign] = useState([]);
    const [paging, setPaging] = useState({ ...INITPAGING, pageNumber: 1, pageSize: 20, orderDirection: "desc", orderBy: "id" });
    const [listColorOptions, setListColorOptions] = useState([]);

    useEffect(() => {
        if (setId > 0) {
            getModel(setId);
            getListDesign(paging);
        }
    }, [setId]);

    const getModel = async (setId) => {
        setLoading(true);
        const [err, data] = await PartnerServices.GetCusSetById(setId);
        if (!err && data) {
            setModel(data);

            let gr = data.colorGroups;
            let list = [];
            for (var element of gr) {
                list.push({ value: element.colorValue, text: element.colorName, label: element.colorName });
            }
            setListColorOptions(list);
        } else {
            setModel({});
        }
        setLoading(false);
    };

    const getListDesign = async (paging) => {
        const [err, data] = await PartnerServices.GetTemplateByPage(paging);
        if (!err && data) {
            setListDesign(data.listObjects);
            setPaging(data.paging);
        } else {
            setListDesign([]);
            setPaging(paging);
        }
    };

    const handleSave = async (models, setId) => {
        const [err, data] = await PartnerServices.CreateUpdateRangeSetGroup(models, setId);
        if (!err) {
            Notify(NOTIFY.SUCCESS, "Thông báo", "Cập nhật thành công");
            history.push("/manage-group-customize");
        } else {
            Notify(NOTIFY.ERROR, "Thông báo", "Cập nhật thất bại");
        }
    };

    const listDesignId = useMemo(() => {
        if (!model || !model.colorGroups) return [];

        let list = [];
        for (var element of model.colorGroups) {
            list.push(element.designId);
        }
        return list;
    }, [model]);

    if (!model) return <div>Không tồn tại dữ liệu</div>;
    return (
        <React.Fragment>
            <Breadcum menu={["Trang chủ", "Nhóm thiết kế", "Thêm thiết kế theo màu"]} title="Thêm thiết kế theo màu" />
            <LoadingR isShow={loading} />
            <Wrapper>
                <div className="box">
                    <div className="left-box">
                        <div className="box-header">
                            <span>Nhóm thiết kế</span>
                        </div>
                        <div className="box-body">
                            <div className="list-color-item">
                                {model.colorGroups &&
                                    model.colorGroups.map((x, index) => {
                                        const isActive = x.isActive;
                                        return (
                                            <div className={`group-color-item ${isActive ? "active" : ""}`} key={index}>
                                                <div className="color-top">
                                                    <div className="color-box">
                                                        {x.productAvatar ? <img src={x.productAvatar} alt="" /> : <div className="color" style={{ backgroundColor: x.colorValue, opacity: 0.3 }}></div>}
                                                        <div className="color-name">
                                                            <span>{x.colorName}</span>
                                                        </div>
                                                    </div>
                                                    {x.productAvatar && (
                                                        <div className="color-default">
                                                            <input
                                                                type="radio"
                                                                name={`radio-default-${index}`}
                                                                id={`radio-default-${index}`}
                                                                checked={x.isDefault}
                                                                onChange={(e) => {
                                                                    let md = { ...model };
                                                                    let gr = md.colorGroups;
                                                                    for (var element of gr) {
                                                                        element.isDefault = false;
                                                                    }
                                                                    gr[index].isDefault = true;
                                                                    setModel({ ...md });
                                                                }}
                                                            />
                                                            <label htmlFor={`radio-default-${index}`}>Mặc định</label>
                                                        </div>
                                                    )}
                                                </div>
                                                {x.productAvatar && (
                                                    <div className="color-bottom">
                                                        <div className="bottom-left">
                                                            <div className="isactive-btn">
                                                                <SwichToogle
                                                                    name={`isactive-${index}`}
                                                                    value={isActive}
                                                                    onCheckChanged={(name, value) => {
                                                                        let md = { ...model };
                                                                        md.colorGroups[index].isActive = value;
                                                                        setModel({ ...md });
                                                                    }}
                                                                />
                                                                <div className="label-active">Hiển thị</div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            className="bottom-right cursor-pointer"
                                                            onClick={(e) => {
                                                                let md = { ...model };
                                                                let colorGroups = md.colorGroups;
                                                                let currentItem = colorGroups[index];
                                                                currentItem.designId = 0;
                                                                currentItem.productAvatar = "";
                                                                currentItem.isActive = false;
                                                                currentItem.isDefault = false;
                                                                currentItem.title = "";
                                                                setModel({ ...md });
                                                            }}
                                                        >
                                                            <div className="trash-button">
                                                                <img src={TrashIcon} alt="" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                            </div>
                            <div className="list-button">
                                <button
                                    className="btn btn-orange"
                                    onClick={(e) => {
                                        let md = { ...model };
                                        let groups = md.colorGroups;
                                        if (groups) {
                                            let lst = [];
                                            for (const group of groups) {
                                                if (group.designId === 0) continue;
                                                lst.push({
                                                    setId: setId,
                                                    colorValue: group.colorValue,
                                                    designId: group.designId,
                                                    isDefault: group.isDefault,
                                                    isActive: group.isActive,
                                                });
                                            }
                                            handleSave(lst, setId);
                                        }
                                    }}
                                >
                                    Hoàn thành
                                </button>
                                <button
                                    className="btn btn-cancel"
                                    onClick={(e) => {
                                        ConfirmDialog("Hủy bỏ", "Bạn có chắc chắn muốn hủy bỏ không?", () => {
                                            return new Promise((resolve, reject) => {
                                                history.push("/manage-group-customize");
                                                resolve({ title: "Thành công", msg: "Hủy bỏ thành công." });
                                            });
                                        });
                                    }}
                                >
                                    Hủy
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="right-box">
                        <div className="box-header">
                            <span>Chọn thiết kế</span>
                            <div className="filter-color">
                                <TFUSelect
                                    placeholder="Chọn màu"
                                    options={listColorOptions}
                                    onChanged={(newVal) => {
                                        getListDesign({ ...paging, pageNumber: 1, colorValue: newVal });
                                    }}
                                    value={paging.colorValue}
                                />
                            </div>
                        </div>
                        <div className="box-body">
                            <div className="list-body-item">
                                {listDesign ? (
                                    listDesign.map((x, index) => {
                                        const isActive = listDesignId.includes(x.id);
                                        return (
                                            <div
                                                className={`body-item ${isActive ? "active" : ""}`}
                                                key={index}
                                                onClick={(e) => {
                                                    let md = { ...model };
                                                    let colorGroups = md.colorGroups;
                                                    let currentItem = colorGroups.find((y) => y.colorValue === x.colorCode);
                                                    if (currentItem) {
                                                        let anyDefault = colorGroups.find((y) => y.isDefault);
                                                        currentItem.designId = x.id;
                                                        currentItem.productAvatar = x.imageUrl;
                                                        currentItem.isActive = true;
                                                        currentItem.isDefault = anyDefault ? false : true;
                                                        currentItem.title = x.title;
                                                        setModel({ ...md });
                                                    } else {
                                                        Notify(NOTIFY.INFO, "Thông báo", "Màu này đã tồn tại trong nhóm thiết kế");
                                                    }
                                                }}
                                            >
                                                <div className="body-avatar">{x.imageUrl && <img src={x.imageUrl} alt="" />}</div>
                                                <div className="body-name">
                                                    <span>{x.title}</span>
                                                </div>
                                                <div className="check-item">
                                                    <input type="checkbox" checked={isActive} />
                                                </div>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div className="no-data">Hiện không có dữ liệu</div>
                                )}
                            </div>
                            <TableFooter
                                paging={paging}
                                onFilter={(paging) => {
                                    getListDesign(paging);
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Wrapper>
        </React.Fragment>
    );
}

export default EditGroupCustomize;

const Wrapper = styled.div`
    width: calc(100% - 48px);
    .list-button button {
        margin: 10px;
    }

    button.btn.btn-orange {
        border-radius: 40px;
        background: #ff9027;
        color: #fff;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    button.btn.btn-cancel {
        border-radius: 40px;
        border: 1px solid #e5e5e5;
        background: #fff;
        color: #303030;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }
    .color-box img {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
    }
    .right-box {
        border-radius: 12px;
        border: 1px solid #f3f3f3;
        background: #fff;
    }

    .box-header {
        display: flex;
        align-items: center;
    }

    .filter-color {
        width: 180px;
        margin-left: 12px;
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .list-body-item {
        display: flex;
        flex-wrap: wrap;
    }

    .body-item {
        width: calc(100% / 6 - 10px);
        margin: 5px;
        /* height: 180px; */
        border-radius: 12px;
        border: 1px solid #e5e5e5;
        background: #fff;
        overflow: hidden;
        position: relative;
    }

    .body-avatar {
        width: 100%;
    }

    .body-avatar img {
        width: 100%;
        object-fit: contain;
        height: 100%;
    }

    .check-item {
        position: absolute;
        top: 10px;
        left: 10px;
        display: flex;
    }

    .body-name {
        overflow: hidden;
        color: #303030;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        padding: 8px;
    }

    .body-item.active {
        border: 1px solid #ff9027;
        background: #ffe8d3;
    }
    .box {
        display: flex;
    }

    .left-box {
        width: 500px;
        flex-shrink: 0;
        border-radius: 12px;
        border: 1px solid #f3f3f3;
        background: #fff;
    }

    .right-box {
        flex: 1;
        margin-left: 32px;
    }

    .box-header span {
        color: #303030;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .box-header {
        padding: 24px;
        border-bottom: 1px solid #f3f3f3;
    }

    .box-body {
        padding: 24px;
    }

    .list-color-item {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
    }

    .group-color-item {
        width: calc(33.33% - 10px);
        height: 230px;
        margin: 5px;
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #fff;
    }

    .color-box {
        width: 100%;
        aspect-ratio: 1;
        border-radius: 8px;
        position: relative;
        /* overflow: hidden; */
    }

    .color {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 8px;
    }

    .color-name span {
        border-radius: 50px;
        border: 1px solid #303030;
        background: #fff;
        color: #303030 !important;
        text-align: center;
        font-family: Lexend;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        padding: 2px 12px;
    }

    .color-name {
        position: absolute;
        bottom: -10px;
        left: 0;
        z-index: 1;
        right: 0;
        display: flex;
        justify-content: center;
    }

    .color-default label {
        margin-bottom: 0;
        color: #303030;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-left: 6px;
    }

    .color-default {
        display: flex;
        align-items: center;
        margin-top: 15px;
    }

    .color-bottom {
        display: flex;
        align-items: center;
        padding: 10px 7px;
    }

    .isactive-btn {
        display: flex;
        align-items: center;

        label {
            color: black;
        }
    }

    .color-top {
        padding: 3px;
    }

    .bottom-right {
        margin-left: auto;
    }

    .group-color-item.active {
        background: #fff5ec;
        border: 1px solid #ff9027;
    }

    .group-color-item.active .color-default label {
        color: #ff9027;
    }
`;
